/**
 * Anonymous identity for demo (free-play) sessions.
 * Never sent to any auth provider, never written to the DB.
 * Persists in localStorage so the same browser keeps the same Guest_XXXX
 * name across reloads and multiple demo runs.
 */

const STORAGE_KEY = 'demo_id';

export function getOrCreateDemoId(): string {
  try {
    const existing = localStorage.getItem(STORAGE_KEY);
    if (existing) return existing;
  } catch { /* ignore — fall through to generate */ }

  const id = (typeof crypto !== 'undefined' && (crypto as any).randomUUID)
    ? (crypto as any).randomUUID()
    : `demo_${Date.now()}_${Math.random().toString(36).slice(2, 10)}`;

  try { localStorage.setItem(STORAGE_KEY, id); } catch { /* ignore */ }
  return id;
}

export function getDemoDisplayName(): string {
  const id = getOrCreateDemoId();
  // First 4 hex chars of the UUID (e.g. "Guest_a3f1")
  const slug = id.replace(/[^a-z0-9]/gi, '').slice(0, 4).toLowerCase();
  return `Guest_${slug || 'snake'}`;
}
